import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ILoggedInUser } from "../../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../../services/common/logged-in-user.service";
import { DistanceModel } from "../../models/distance.model";
import { EmployeeCategoriesService } from "../../services/employee-categories.service";
import { ManageEmployeeCategoryModel } from "../../models/manage-employee-category.model";

@Component({
  selector: "app-manage-employee-categories",
  templateUrl: "./manage-employee-categories.component.html",  
  standalone: true,  
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule],
})
export class ManageEmployeeCategoriesComponent implements OnInit {
  isLoading: boolean = false;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  distanceModel: DistanceModel
  title: string  = "";
  buttonName: string = "";
  form: FormGroup;
  information: string = "";
  confirmation: string = "Confirm that you want to remove this Employee Category.";
  isAdding: boolean = false;

  constructor(  
    @Inject(MAT_DIALOG_DATA) public data: { code: string,},
    public dialogRef: MatDialogRef<ManageEmployeeCategoriesComponent>,
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private employeeCategoriesService: EmployeeCategoriesService
  ) {}

  ngOnInit(): void {
    if(this.data.code === ""){
      this.isAdding = true;
    }

    if(this.isAdding ){
      this.buttonName = "Add";
      this.title = "New Employee Category";
    } else {
      this.buttonName = "Update";
      this.title = "Edit Employee Category";
    }
   
    this.form = this.fb.group({
      description: new FormControl(''),
      fromPsg: new FormControl(''),
      toPsg: new FormControl(''),
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.getEmployeeCategoryModel();
      }      
    });
  }  

  getEmployeeCategoryModel() {
    if(this.isAdmin){
      this.isLoading = true;
      this.employeeCategoriesService.searchEmployeeCategory(this.data.code).subscribe({
        next: (result) => {
          this.form.patchValue(result);
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error retriving employee category: ', err);
          this.isLoading = false;
        }
      })
    }
  }

  getformValues(): ManageEmployeeCategoryModel{
    return {
      code: this.data.code,
      fromPsg: this.form.get('fromPsg')?.value || null,
      toPsg: this.form.get('toPsg')?.value || null,
      description: this.form.get('description')?.value,
      userEmail: this.user?.userEmail,
      userName: this.user?.userName
    };
  }

  tryDelete(){
    if(confirm("Confirm that you want to remove this employee category.")) {
      this.delete();
    }
  }

  delete(){
    if(!this.isAdding){
      this.employeeCategoriesService.deleteEmployeeCategory(this.data.code).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Employee category deleted.";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error deleting employee category: ', err);
          this.information = 'Could not delete this employee category.';
        }
      });
    }
  }

  startAction(){
    if(!this.isAdding){      
      this.employeeCategoriesService.updateEmployeeCategory(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Employee category updated";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error updating employee category: ', err);
          this.information = 'Could not change employee category.';
        }
      });
    }
    else{
      this.employeeCategoriesService.addEmployeeCategory(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Employee category added.";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error adding employee category: ', err);
          this.information = 'Could not add employee category.';
        }
      });
    }
  }
  
  close() {
    this.dialogRef.close();
  }
}
